import { useSelector } from 'react-redux';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { getPromoById } from 'reactApp/modules/promoTariffs/promoTariffs.selectors';
import type { RootState } from 'reactApp/store';

export const useSubscription = ({ id }: { id: string }) => {
    const basicSubscription = useSelector(BillingDataSelectors.getBasicSubscription);
    const subscription = useSelector((state: RootState) => BillingDataSelectors.getSubscriptionsById(state, id));
    // @ts-ignore
    const promoSubscriptions = useSelector((state: RootState) => getPromoById(state, id));

    if (id === 'base') {
        return basicSubscription;
    }

    return subscription || promoSubscriptions;
};
